import Form_3 from './Form_3-redux';

export default Form_3;
